import { useTranslation } from 'react-i18next';
import { BaseModal } from '@/components/modal/BaseModal';
import { MediaBin } from '../MediaBin';
import { UploadDropzone } from '../UploadDropzone';
import { useImportToProject } from '../../hooks/useImportToProject';

interface MobileMediaSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMediaSheet({ isOpen, onClose }: MobileMediaSheetProps) {
  const { t } = useTranslation();
  const { importAsset } = useImportToProject();

  const handleAssetTap = (assetId: string) => {
    onClose();
    importAsset(assetId);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      mobileVariant="bottomsheet"
      ariaLabel={t('editor.mediaBin', 'Media')}
    >
      <div className="flex flex-col h-full max-h-[80dvh]">
        {/* Drag handle */}
        <div className="flex justify-center py-2 shrink-0">
          <div className="w-8 h-1 rounded-full bg-white/20" />
        </div>

        {/* Header */}
        <div className="px-4 pb-2 shrink-0">
          <h3 className="text-sm font-semibold text-[var(--user-page-text)]">
            {t('editor.mediaBin', 'Media')}
          </h3>
        </div>

        {/* Upload */}
        <div className="px-4 pb-3 shrink-0">
          <UploadDropzone />
        </div>

        {/* Media grid — tap to import on mobile */}
        <div className="flex-1 overflow-y-auto px-4 pb-4 min-h-0">
          <MediaBin onAssetTap={handleAssetTap} />
        </div>
      </div>
    </BaseModal>
  );
}
